var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6501 10.9996C6.6501 8.59717 8.59766 6.64961 11.0001 6.64961C13.4025 6.64961 15.3501 8.59717 15.3501 10.9996C15.3501 13.402 13.4025 15.3496 11.0001 15.3496C8.59766 15.3496 6.6501 13.402 6.6501 10.9996ZM11.0001 5.34961C7.87969 5.34961 5.3501 7.8792 5.3501 10.9996C5.3501 14.12 7.87969 16.6496 11.0001 16.6496C12.3373 16.6496 13.5659 16.1851 14.5335 15.4087C14.5619 15.5161 14.6181 15.6176 14.7024 15.7019L17.7831 18.7826C18.037 19.0365 18.4485 19.0365 18.7024 18.7826C18.9562 18.5288 18.9562 18.1172 18.7024 17.8634L15.6216 14.7826C15.5405 14.7015 15.4433 14.6464 15.3404 14.6171C16.1581 13.637 16.6501 12.3758 16.6501 10.9996C16.6501 7.8792 14.1205 5.34961 11.0001 5.34961Z",
    fill: "#657D9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b79b5d15.svg";
export { ForwardRef as ReactComponent };